import Breadcrumb from "components/Common/Breadcrumb"
import QwikForm from "components/form/QwikForm"
import QwikInput from "components/form/QwikInput"
import QwikSelect from "components/form/QwikSelect"
import React, { useState } from "react"
import { Col, Container, Row, FormGroup, Label } from "reactstrap"
import {
  useCreateUserMutation,
  useGetAllUsersQuery,
} from "store/features/users/userManagementApi"
import { toast } from "sonner"
import hashPassword from "utils/hashPassword"
import { useNavigate } from "react-router-dom"
import Select from "react-select"

const CreateUser = () => {
  const [createUser, { isLoading }] = useCreateUserMutation()
  const { data: users, isLoading: isLoadingTwo } = useGetAllUsersQuery()

  const [profileImage, setProfileImage] = useState(null)
  const [crmPermissions, setCrmPermissions] = useState([])
  const navigate = useNavigate()

  // Define available CRM permissions
  const crmPermissionOptions = [
    { value: "qwik_it", label: "Softzen IT" },
    { value: "qwik_medic", label: "Qwik Medic" },
    { value: "qwik_bistro", label: "Qwik Bistro" },
  ]

  const handleSubmit = async data => {
    try {
      const emailExists = users?.some(
        user =>
          user.personal_email == data.personal_email ||
          (data.official_email && user.official_email == data.official_email)
      )

      if (emailExists) {
        toast.error("Email already exists. Please use a different email.")
        return // Stop execution if email exists
      }

      const formData = new FormData()

      // Append user data
      formData.append("role", data.role)
      formData.append("nickname", data.nickname)
      formData.append("personal_email", data.personal_email)
      formData.append("phone", data.phone || "")
      formData.append("emp_id", data.emp_id || "")
      formData.append("official_email", data.official_email || "")
      formData.append("date_of_birth", data.date_of_birth || "")
      formData.append("gender", data.gender || "")
      formData.append("address", data.address || "")
      formData.append("position", data.position || "")
      formData.append("experience_years", data.experience_years || "")
      formData.append("blood_group", data.blood_group || "")
      formData.append("joining_date", data.joining_date || "")
      formData.append("city", data.city || "")

      // Append CRM permissions as JSON string
      formData.append("default_crm", "qwik_it")
      formData.append("crm_permissions", JSON.stringify(crmPermissions))

      // Hash password
      const hashedPassword = await hashPassword(data.password)
      formData.append("password_hash", hashedPassword)

      // Append profile image if selected
      if (profileImage) {
        formData.append("image", profileImage)
      }

      await createUser(formData).unwrap()

      // Reset form
      setProfileImage(null)

      setTimeout(() => {
        navigate("/all-users")
      }, 2000)
    } catch (error) {
      toast.error("Failed to create user")
      console.error("User creation error:", error)
    }
  }

  const handleImageChange = event => {
    const file = event.target.files[0]
    setProfileImage(file)
  }

  const getFileName = file => {
    return file ? file.name : "No file chosen"
  }

  const handleCrmPermissionsChange = selectedOptions => {
    const values = selectedOptions
      ? selectedOptions.map(option => option.value)
      : []
    setCrmPermissions(values)
  }

  const getSelectedCrmOptions = () => {
    return crmPermissionOptions.filter(option =>
      crmPermissions.includes(option.value)
    )
  }

  return (
    <div className="page-content px-4">
      <Container fluid={true}>
        <Breadcrumb title="Users" breadcrumbItem="Create User" />
        <Row>
          <QwikForm onSubmit={handleSubmit}>
            <Col className="col-12">
              <Row>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="nickname"
                      label="Name"
                      placeholder="Enter name"
                      type="text"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="personal_email"
                      label="Email"
                      placeholder="Enter personal email"
                      type="email"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="phone"
                      label="Phone Number"
                      placeholder="Enter phone number"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col>
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="emp_id"
                      label="Employee ID"
                      placeholder="Enter employee ID"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col> */}
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="official_email"
                      label="Official Email"
                      placeholder="Enter official email"
                      type="email"
                      className="form-control"
                    />
                  </div>
                </Col> */}
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="password"
                      label="Password"
                      placeholder="Enter password"
                      type="password"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="confirm_password"
                      label="Confirm Password"
                      placeholder="Confirm password"
                      type="password"
                      className="form-control"
                      required
                    />
                  </div>
                </Col> */}
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="date_of_birth"
                      label="Date of Birth"
                      type="date"
                      className="form-control"
                    />
                  </div>
                </Col> */}

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikSelect
                      name="role"
                      label="Role"
                      options={[
                        { value: "admin", label: "Admin" },
                        { value: "project_manager", label: "project Manager" },
                        { value: "developer", label: "Developer" },
                        // { value: "client", label: "Client" },
                        { value: "marketing", label: "Marketing" },
                        { value: "designer", label: "Designer" },
                        { value: "hr", label: "HR" },
                      ]}
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikSelect
                      name="gender"
                      label="Gender"
                      options={[
                        { value: "male", label: "Male" },
                        { value: "female", label: "Female" },
                        { value: "other", label: "Other" },
                      ]}
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="position"
                      label="Position"
                      placeholder="Enter position"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col>
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="experience_years"
                      label="Experience (Years)"
                      placeholder="Enter years of experience"
                      type="number"
                      className="form-control"
                    />
                  </div>
                </Col> */}
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="joining_date"
                      label="Joining Date"
                      type="date"
                      className="form-control"
                    />
                  </div>
                </Col> */}
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikSelect
                      name="blood_group"
                      label="Blood Group"
                      options={[
                        { value: "A+", label: "A+" },
                        { value: "A-", label: "A-" },
                        { value: "B+", label: "B+" },
                        { value: "B-", label: "B-" },
                        { value: "AB+", label: "AB+" },
                        { value: "AB-", label: "AB-" },
                        { value: "O+", label: "O+" },
                        { value: "O-", label: "O-" },
                      ]}
                    />
                  </div>
                </Col> */}
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="city"
                      label="City"
                      placeholder="Enter city"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col> */}
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="address"
                      label="Address"
                      placeholder="Enter full address"
                      type="text"
                      className="form-control"
                      // rows="3"
                    />
                  </div>
                </Col>

                {/* CRM Permissions Multi-Select */}
                <Col lg={6}>
                  <div className="mb-3">
                    <Label className="form-label">CRM Permissions</Label>
                    <Select
                      isMulti
                      name="crm_permissions"
                      options={crmPermissionOptions}
                      value={getSelectedCrmOptions()}
                      onChange={handleCrmPermissionsChange}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select CRM permissions..."
                      closeMenuOnSelect={false}
                    />
                    <small className="form-text text-muted">
                      Select one or multiple CRM permissions for this user
                    </small>
                  </div>
                </Col>

                {/* Profile Image Upload */}
                <Col lg={6}>
                  <FormGroup>
                    <Label for="profile_image" className="form-label">
                      Profile Image
                    </Label>
                    <div className="custom-file">
                      <input
                        type="file"
                        className="custom-file-input"
                        id="profile_image"
                        accept=".jpg,.jpeg,.png,.gif"
                        onChange={handleImageChange}
                      />
                      {/* <label
                        className="custom-file-label"
                        htmlFor="profile_image"
                      >
                        {getFileName(profileImage)}
                      </label> */}
                    </div>
                    {/* <small className="form-text text-muted">
                      Upload profile image (JPG, PNG, GIF)
                    </small> */}
                  </FormGroup>
                </Col>

                <div className="col-sm-6 text-start mt-4">
                  <button
                    className="btn btn-primary w-md waves-effect waves-light"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "Creating..." : "Create"}
                  </button>
                </div>
              </Row>
            </Col>
          </QwikForm>
        </Row>
      </Container>
    </div>
  )
}

export default CreateUser
